import emailTable from './emailTable'
import detailedList from './detailedList'
import sendReport from './sendReport'
import editEmail from './editEmail'
import editContactList from './editContactList'
import filterData from './filterStore'

import { getEmailNum, payEmail } from '@/services/edm'

export default {
  namespaced: true,
  state: {
    emailNum: {
      num: '',
      testNum: 0
    }
  },
  mutations: {
    GET_EMAIL_NUM (state, data) {
      state.emailNum.num = data.num
      state.emailNum.testNum = data.testNum
    }
  },
  actions: {
    async fetchEmailNum ({ commit }, params) {
      let chain = await getEmailNum()
      chain
        .params(params)
        .config({ tip: false, warn: false })
        .onSuccess(raw => {
          commit('GET_EMAIL_NUM', raw)
        })
        .fetch()
      return chain
    },
    async payEmail ({ commit }, params) {
      let chain = await payEmail()
      chain
        .params(params)
        // .config({ tip: false, warn: false })
        .fetch()
      return chain
    }
  },
  modules: {
    emailTable,
    detailedList,
    sendReport,
    editEmail,
    editContactList,
    filterData
  }
}
